module.exports = __webpack_public_path__ + "img/3words_title.afeb16c9.png";